import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {uk} from './uk';
import {en} from './en';

i18n
	.use(LanguageDetector) // Подключаем определение языка
	.use(initReactI18next)
	.init({
		resources: {
			en: en,
			uk: uk,
		},
		fallbackLng: 'uk', // Язык по умолчанию
		detection: {
			order: ['localStorage', 'cookie', 'navigator'], // Где искать язык
			caches: ['localStorage', 'cookie'], // Куда сохранять выбранный язык
		},
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
